import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.ORDER_STATUS_LIST_CLEAR_STORE){

        let oldOrderStatusList = undefined;
        if(!!state){
            oldOrderStatusList = state.orderStatusList;
        }

        state = {
            name: "Тест",

            orderStatusListSummury: [],
            orderStatusList: oldOrderStatusList || [],
            userList: [],
            isLoading: false,
            isSave: false,
            isLoaded: false
        };

    }

    switch(action.type){
        case constants.ORDER_STATUS_LIST_SUMMURY_LOAD_START:
            return {...state, ...{orderStatusListSummury: [], isLoading: true, error: undefined}};
        case constants.ORDER_STATUS_LIST_SUMMURY_LOAD_SUCCESS:
            return { ...state, ...{orderStatusListSummury: action.data, isLoading: false}};
        case constants.ORDER_STATUS_LIST_SUMMURY_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.ORDER_STATUS_LIST_LOAD_START:
            return {...state, ...{orderStatusList: [], isLoading: true, error: undefined}};
        case constants.ORDER_STATUS_LIST_LOAD_SUCCESS:
            return { ...state, ...{orderStatusList: action.data, isLoading: false}};
        case constants.ORDER_STATUS_LIST_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.ORDER_STATUS_LIST_REMOVE_START:
            return {...state, ...{isLoading: true}};
        case constants.ORDER_STATUS_LIST_REMOVE_SUCCESS:
            return { ...state, ...{isLoading: false, isShouldReload: true}};
        case constants.ORDER_STATUS_LIST_REMOVE_FAIL:
            return {...state, ...{isLoading: true, error: action.error}};

        default:
            return state;
    }
}
